import ArrowWithTail from "../../../assets/icons/ArrowWithTail";
import classes from "./ClemVision.module.scss";

const content = [
  {
    imgSrc:
      "https://se-website-image.s3.ap-south-1.amazonaws.com/clem/clem-vision/clem-transition.png",
    title: "CLEM Transition",
    description: "Making clean energy transition profitable",
    linkText: "Go to CLEM Transition",
    sectionId: "clem-transition",
  },
  {
    imgSrc:
      "https://se-website-image.s3.ap-south-1.amazonaws.com/clem/clem-vision/clem-enablement.png",
    title: "CLEM Enablement",
    description: "Making clean energy projects bankable",
    linkText: "Go to CLEM Enablement",
    sectionId: "clem-enablement",
  },
];

function ClemVision() {
  const handleScrollToSection = (id: string) => {
    const targetSection = document.getElementById(id);

    if (targetSection) {
      const targetPosition = targetSection.offsetTop;

      window.scrollTo({
        top: targetPosition - 95,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.title}>CLEM Vision</div>

      <div className={classes["news-imgs-container"]}>
        {content.map((item, index) => (
          <div key={index} className={classes["news-img-card"]}>
            <div className={classes["img-content-container"]}>
              <img
                src={item.imgSrc}
                alt={item.title}
                className={classes["news-img"]}
              />
              <div className={classes["news-content"]}>
                <div className={classes["news-title"]}>{item.title}</div>
                <div className={classes["description"]}>{item.description}</div>
                <div
                  className={classes["link"]}
                  onClick={() => handleScrollToSection(item.sectionId)}
                >
                  {item.linkText} <ArrowWithTail color="#1868DB" />
                </div>
              </div>
            </div>

            <div className={classes["background-box"]}></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ClemVision;
